import Router from "vue-router";

const routerPush = Router.prototype.push;
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch((err) => {});
};

let routes = [
  {
    path:"/",
    name:"home",
    component:()=>import('@/view/home.vue')
  },
  {
    path:"/login",
    name:"login",
    component:()=>import('@/view/login.vue')
  },
  {
    path:"/agree",
    name:"agree",
    component:()=>import('@/view/agree.vue')
  },
  {
    path:"/register",
    name:"register",
    component:()=>import('@/view/register.vue')
  },
  {
    path:"/grade",
    name:"grade",
    component:()=>import('@/view/learning/grade.vue')
  },
  {
    path:"/word",
    name:"word",
    component:()=>import('@/view/learning/word.vue')
  },
  {
    path:"/ranking",
    name:"ranking",
    component:()=>import('@/view/learning/ranking.vue')
  },
  {
    path:"/history",
    name:"history",
    component:()=>import('@/view/dictionary/history.vue')
  },
  {
    path:"/course",
    name:"course",
    component:()=>import('@/view/service/course.vue')
  },
  {
    path:"/chapter",
    name:"chapter",
    component:()=>import('@/view/service/chapter.vue')
  },
  {
    path:"/wordbook",
    name:"wordbook",
    component:()=>import('@/view/service/wordbook.vue')
  },
  {
    path:"/usercenter",
    name:"usercenter",
    component:()=>import('@/view/personal/usercenter.vue')
  },
  {
    path:"/cardkey",
    name:"cardkey",
    component:()=>import('@/view/personal/cardkey.vue')
  },
  {
    path:"/edit",
    name:"edit",
    component:()=>import('@/view/personal/edit.vue')
  },
  {
    path:"/password",
    name:"password",
    component:()=>import('@/view/personal/password.vue')
  },
  {
    path:"/newsword",
    name:"newsword",
    component:()=>import('@/view/service/newsword.vue')
  }
];

let router = new Router({
  routes,
});

export default router;
